import { EntityDefinition } from '@/types/crud';

export const abacUserEntity: EntityDefinition = {
  name: 'abacUser',
  displayName: 'Users',
  apiEndpoint: '/abac/users',
  idField: 'id',
  nameField: 'email',
  copyable: false,
  deletable: false, // Users shouldn't be deleted via this interface
  searchable: true,
  sortable: true,
  pageSize: 20,
  fields: [
    {
      key: 'id',
      label: 'abac.fieldLabels.id',
      type: 'text',
      hidden: true,
      order: 0
    },
    {
      key: 'email',
      label: 'abac.fieldLabels.email',
      type: 'text',
      required: true,
      readOnly: true,
      order: 1,
      width: '200px'
    },
    {
      key: 'first_name',
      label: 'abac.fieldLabels.firstName',
      type: 'text',
      required: true,
      readOnly: true,
      order: 2,
      width: '120px'
    },
    {
      key: 'last_name',
      label: 'abac.fieldLabels.lastName',
      type: 'text',
      required: true,
      readOnly: true,
      order: 3,
      width: '120px'
    },
    {
      key: 'status',
      label: 'abac.fieldLabels.status',
      type: 'text',
      readOnly: true,
      order: 4,
      width: '100px'
    },
    {
      key: 'tenant_name',
      label: 'abac.fieldLabels.tenant',
      type: 'text',
      readOnly: true,
      order: 4.5,
      width: '150px',
      render: (value: string, user: any) => {
        if (!value) return '-';
        const badgeClass = user.user_type === 'PARTNER_TENANT' 
          ? 'bg-blue-100 text-blue-800' 
          : 'bg-green-100 text-green-800';
        const badgeText = user.user_type === 'PARTNER_TENANT' ? 'Partner' : 'Current';
        return `<div class="flex items-center gap-2">
          <span class="text-sm">${value}</span>
          <span class="px-2 py-1 text-xs rounded-full ${badgeClass}">
            ${badgeText}
          </span>
        </div>`;
      }
    },
    {
      key: 'custom_attributes',
      label: 'abac.fieldLabels.customAttributes',
      type: 'custom',
      readOnly: true,
      formHidden: true,
      order: 5,
      width: '300px',
      render: (value: any[]) => {
        if (!value || value.length === 0) {
          return 'No attributes assigned';
        }
        
        const formatValue = (val: any) => {
          if (val === null || val === undefined) return 'N/A';
          
          // Check if it's a date string (ISO format)
          if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
            try {
              return new Date(val).toLocaleDateString();
            } catch {
              return val;
            }
          }
          
          // Check if it's a boolean
          if (typeof val === 'boolean') {
            return val ? 'Yes' : 'No';
          }
          
          return String(val);
        };
        
        return value.map((attr: any) => 
          `${attr.attribute_name}: ${Array.isArray(attr.value) 
            ? attr.value.map((v: any) => formatValue(v)).join(', ')
            : formatValue(attr.value)
          }`
        ).join('<br>');
      }
    },
    {
      key: 'created_at',
      label: 'abac.fieldLabels.createdAt',
      type: 'datetime',
      readOnly: true,
      order: 6,
      width: '140px'
    }
  ]
};
